<p-fluid>
    <div class="grid flex mb-5">
        <div class="col-12 flex align-items-center justify-content-between">
            <h1 class="mt-0 mb-0">
                Containers for forecast:
                @if (forecast) {
                    {{ forecast.planningParameter.manufacturer.name }}
                    – {{ forecast.planningParameter.name }}
                    – {{ forecast.month }}/{{ forecast.year }}
                }
            </h1>
            <div class="flex gap-2">
                <p-button
                    label="Save All"
                    icon="pi pi-save"
                    [loading]="saving"
                    (onClick)="saveAll()"/>
                <p-button
                    label="Import from Clipboard"
                    icon="pi pi-upload"
                    severity="secondary"
                    (onClick)="importDialogVisible = true"/>
            </div>
        </div>
    </div>
</p-fluid>

<app-container-import-dialog
    [(visible)]="importDialogVisible"
    [customFields]="customFields"
    [existingContainers]="containers"
    (confirmImport)="onImportConfirmed($event)"/>

@if (customFields.length > 0) {
    <div class="grid flex">
        @for (container of containers; track container.id) {
            <div class="col-12">
                <app-container-panel
                    [forecast]="forecast!"
                    [container]="container"
                    [customFields]="customFields"/>
            </div>
        }
    </div>
}
